import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Button, ButtonGroup } from "shards-react";
import { NavLink } from "react-router-dom";

import PageTitle from "../components/common/PageTitle";
import SmallStats from "../components/common/SmallStats";
import Sessions from "../components/analytics/Sessions";
import UsersByDevice from "../components/analytics/UsersByDevice";
import TopReferrals from "../components/common/TopReferrals";


import DevicesPerApp from "../components/common/DevicesPerApp";

import AppsDistribution from "../components/common/AppsDistribution";

import GoalsOverview from "../components/analytics/GoalsOverview/GoalsOverview";
import CountryReports from "../components/common/CountryReports";
import colors from "../utils/colors";
import './loaderStyles.css';

import { useAuth } from '../context/AuthContext';

const Analytics = () => {
  const [smallStats, setSmallStats] = useState([]);
  
  const { login } = useAuth(); 
  const { logout } = useAuth(); 
  

  const [usersByDeviceData, setUsersByDeviceData] = useState({
    labels: ["Android", "iOS"],
    datasets: [
      {
        hoverBorderColor: colors.white.toRGBA(1),
        data: [0, 0],
        icons: [
          '<i class="fab fa-android"></i>',
          '<i class="fab fa-apple"></i>',
        ],
        backgroundColor: [
          colors.primary.toRGBA(0.9),
          colors.primary.toRGBA(0.5),
        ],
      },
    ],
  });
    const [appsVersionData, setappsVersionData] = useState([]);

  const [androidVersionData, setAndroidVersionData] = useState([]);

    const [appsData, setappsData] = useState([]);


  const [iosVersionData, setIosVersionData] = useState([]);
  const [loading, setLoading] = useState(true); // Overall loading state
  const [androidLoading, setAndroidLoading] = useState(true); // Loader for Android version distribution
  const [iosLoading, setIosLoading] = useState(true); // Loader for iOS version distribution

  useEffect(() => {
     const comp_id=localStorage.getItem('company_id');
     const token=localStorage.getItem('token');
     
     if(!comp_id||comp_id==''||!token||token==''){ 
      logout();
    }

    const fetchData = async () => {
      try {
        const response = await fetch("https://vaptlabreport.com/shieldapi/events.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ company_id: comp_id }),
        });

        const apiData = await response.json();
        const { data } = apiData;

        // Update smallStats with Android-specific data
        setSmallStats([
          {
           
            label: <h6 className="m-0" >Threat Events</h6>,

            value: data.Threats.android.total_threats || "0",
            chartData: [{ data: [0] }],
            chartLabels: [null],
            percentage: "0%",
            increase: true,
            decrease: false,
          },
          {
            label: <h6 className="m-0" > Unique Devices </h6>,
            value: data.Unique_Devices.android || 0+data.Unique_Devices.ios || 0,
            chartData: [{ data: [0] }],
            chartLabels: [null],
            percentage: "0%",
            increase: true,
            decrease: false,
          },
          {
            label: <h6 className="m-0" > Applications </h6>,
            value: data.Apps.length || "0",
            chartData: [{ data: [0] }],
            chartLabels: [null],
            percentage: "0%",
            increase: true,
            decrease: false,
          },
          {
            label: <h6 className="m-0" > Rooted Devices </h6>,
            value: data.Threats.android.isRooted || "0",
            chartData: [{ data: [0] }],
            chartLabels: [null],
            percentage: "0%",
            increase: true,
            decrease: false,
          },
        ]);

        // Update UsersByDevice data with the API's devices_per_os
        const devicesPerOs = data.devices_per_os;
        const androidData = devicesPerOs.find((device) => device.os === "android") || { percentage: "0%" };
        const iosData = devicesPerOs.find((device) => device.os === "ios") || { percentage: "0%" };

        setUsersByDeviceData({
          labels: ["Android", "iOS"],
          datasets: [
            {
              hoverBorderColor: colors.white.toRGBA(1),
              data: [parseFloat(androidData.percentage), parseFloat(iosData.percentage)],
              icons: [
                '<i class="fab fa-android"></i>',
                '<i class="fab fa-apple"></i>',
              ],
              backgroundColor: [
                colors.primary.toRGBA(0.9),
                colors.primary.toRGBA(0.5),
              ],
            },
          ],
        });

        // Update TopReferrals with Android and iOS version distribution
        setAndroidVersionData(data.version.android || []);

        setappsData(data.Apps || []);
        
        setappsVersionData(data.devices_per_app || []);

        setIosVersionData(data.version.ios || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        logout();
      } finally {
        setLoading(false);
        setAndroidLoading(false);
        setIosLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle title="Analytics" subtitle="Overview" className="text-sm-left mb-3" />
        <Col xs="12" sm="4" className="col d-flex align-items-center">
          <ButtonGroup size="sm" className="d-inline-flex mb-3 mb-sm-0 mx-auto">
            <Button theme="white" tag={NavLink} to="/analytics">Android/iOS</Button>
           {/*     <Button theme="white" tag={NavLink} to="/analytics_ios">iOS</Button> */}
          </ButtonGroup>
        </Col>
      </Row>

      {/* Small Stats Blocks */}
      <Row style={{ position: 'relative', minHeight: '100px' }}>
        {loading ? (
          <div className="loader-container" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <div className="spinner"></div>
          </div>
        ) : (
          smallStats.map((stats, idx) => (
            <Col key={idx} md="6" lg="3" className="mb-4">
              <SmallStats
                id={`small-stats-${idx}`}
                chartData={stats.chartData}
                chartLabels={stats.chartLabels}
                label={stats.label}
                value={stats.value}
                percentage={stats.percentage}
                increase={stats.increase}
                decrease={stats.decrease}
              />
            </Col>
          ))
        )}
      </Row>

      {/* Users By Device */}
      <Row>
      {/*

        <Col lg="8" md="12" sm="12" className="mb-4">
          <Sessions />
        </Col>

      */}

      

        {/* Android Version Distribution with Loader */}
        <Col lg="3" sm="6" className="mb-4">
          <TopReferrals
            title="Android Version Distribution"
            referralData={androidVersionData.map(item => ({
              title: item.version,
              value: item.percentage,
            }))}
            loading={androidLoading} // Pass the loading state for Android
          />
        </Col>

        {/* iOS Version Distribution card with Loader */}
        {iosVersionData.length > 0 && (
        <Col lg="3" sm="6" className="mb-4">
          <TopReferrals
            title="iOS Version Distribution"
            referralData={iosVersionData.map(item => ({
              title: item.version,
              value: item.percentage,
            }))}
            loading={iosLoading} // Pass the loading state for iOS
          />

        </Col>
         )}


         {/* devices per app Distribution with Loader */}
        <Col lg="3" sm="6" className="mb-4">
          <DevicesPerApp
            title="Devices Per App Distribution"
            referralData={appsVersionData.map(item => ({
              title: item.app,
              value: item.percentage,
            }))}
            loading={androidLoading} // Pass the loading state for Android
          />
        </Col>

        {/* App Distribution with Loader */}
        <Col lg="3" sm="6" className="mb-4">
          <AppsDistribution
            title="Apps Distribution"
            referralData={appsData.map(item => ({
              title: item
            
            }))}
            loading={androidLoading}
              iconClass="fas fa-mobile-alt"
          />
        </Col>

{/*
        <Col lg="5" className="mb-4">
          <GoalsOverview />
        </Col>

      */ }

{ /*
        <Col lg="4" className="mb-4">
          <CountryReports />
        </Col>

      */ }

  <Col lg="4" md="6" sm="6" className="mb-4">
          <UsersByDevice chartData={usersByDeviceData} loading={loading} />
        </Col>

      </Row>
    </Container>
  );
};

Analytics.propTypes = {
  smallStats: PropTypes.array,
};

export default Analytics;
